import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from '@boxx/shared-components';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { CategoryFormComponent} from './category-form/category-form.component';
import { DetailFormComponent } from './detail-form/detail-form.component';
import { ProductFormComponent } from './product-form/product-form.component';
import { StoreImagePickerPage } from './store-image-picker/store-image-picker.page';
import { CouponFormComponent } from './coupon-form/coupon-form.component';
// import { ProfilePage } from '@app/pages/store/profile/profile.page';
import { ImageUtilsService } from 'src/services/ImageUtils.service';
import { SunbategoryFormComponent } from './subcategory-form/subcategory-form.component';

@NgModule({
  declarations: [
    CategoryFormComponent, 
    SunbategoryFormComponent,
    ProductFormComponent,
    CouponFormComponent,
    StoreImagePickerPage,
    DetailFormComponent,
    //ProfilePage
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    SharedComponentsModule,
  ],
  exports: [CategoryFormComponent, SunbategoryFormComponent, ProductFormComponent, DetailFormComponent, 
    //ProfilePage, 
    StoreImagePickerPage, CouponFormComponent],
  providers: [ImageUtilsService],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class StoreCoreComponentsModule {}
